import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

const OFFICER_ROLES = [
  "President", "Vice President", "General Secretary", "Assistant General Secretary",
  "Treasurer", "Financial Secretary", "Cultural Officer", "PRO", "Organizer",
  "Assistant Organizer", "Welfare Officer", "Internal Auditor", "Chaplain", "Electoral Commissioner",
  "Trustee", "Committee", "Electoral Committee", "Admin",
];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = user

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);
  const register = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  }, []);
  const logout = useCallback(async () => {
    await api.post("/auth/logout");
    setUser(false);
  }, []);

  const isOfficer = !!user && (user.is_officer ?? OFFICER_ROLES.includes(user.role));
  const permissions = useMemo(() => (user && user.permissions) || [], [user]);
  const can = useCallback((p) => permissions.includes(p), [permissions]);
  const actions = useMemo(() => ({ login, register, logout, refresh }), [login, register, logout, refresh]);
  const value = useMemo(() => ({ user, setUser, isOfficer, permissions, can, ...actions }), [user, isOfficer, permissions, can, actions]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { OFFICER_ROLES };
